import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';

import { GetLostLogoIcon } from '../icons/getlost-logo';
import { GetLostIcon } from '../icons/getlost';

type TitleProps = {
    collapsed: boolean;
};

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
    return (
        <Link to="/">
            <Box
                display="flex"
                alignItems="center"
                gap={'12px'}
                sx={{
                    color: 'text.primary'
                }}
            >
                {collapsed ? (
                    <GetLostLogoIcon width="28" height="24" />
                ) : (
                    <>
                        <GetLostLogoIcon width="28" height="24" />
                        <GetLostIcon width="120" height="20" />
                    </>
                )}
            </Box>
        </Link>
    );
};
